import {
  ExtractFetchParams,
  ExtractResponse,
  ExtractSuspenseQueryOptions,
  useSuspenseRequest,
} from "@/lib/openapi/hooks";

export type UseBllsBalanceResponse = ExtractResponse<
  "serviceBilling",
  "/ballance/{address}",
  "get"
>;

export type UseBllsBalanceFetchParams = ExtractFetchParams<
  "serviceBilling",
  "/ballance/{address}",
  "get"
>;

export const useBllsBalanceQuery = <
  Response extends UseBllsBalanceResponse,
  Transformed = Response
>(
  {
    queryOptions,
    fetchParams,
  }: {
    queryOptions?: ExtractSuspenseQueryOptions<Response, Transformed>;
    fetchParams?: UseBllsBalanceFetchParams;
  } = { queryOptions: { errorResult: { balance: 0 } as unknown as Response } }
) =>
  useSuspenseRequest("serviceBilling", "/ballance/{address}", {
    method: "get",
    queryOptions,
    fetchParams,
  });
